import React, { useContext } from 'react';
import { get, isArray, isString, map } from '@libs/shared';
import { PLUGIN_ARGUMENT_FIELD_TYPE, PLUGIN_ARGUMENT_VALUE_FROM } from '../../../interfaces';
import { PluginComponentContext } from '../plugin-component';
import FieldVariableSelect from '../field-variable-select';
import { CustomCombo } from '../../../components';

/**
 * 插件-下拉框字段
 */
const PluginSelect = () => {
    const pluginComponentStore = useContext(PluginComponentContext);

    if (!pluginComponentStore) {
        return null;
    }

    const { field, fieldValue, isView, checkStatusVisible, onChange } = pluginComponentStore;

    const renderContext = () => {
        const selectType = get(fieldValue, 'resolver_type', PLUGIN_ARGUMENT_VALUE_FROM.LITERAL);
        const { isRequired, isEnabled, fieldConf } = field;
        const value = fieldValue.resolver_arg;

        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.LITERAL) {
            return (
                <CustomCombo
                    disabled={!isEnabled}
                    isView={isView}
                    status={checkStatusVisible && isRequired && !value ? 'error' : undefined}
                    items={map(get(fieldConf, 'items', []), (v) => {
                        return {
                            text: v.text,
                            value: v.value
                        };
                    })}
                    value={isString(value) ? value : undefined}
                    onChange={(v) => {
                        onChange(v);
                    }}
                />
            );
        }
        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.PROCESS_VAR) {
            return (
                <FieldVariableSelect
                    value={isArray(value) ? value : undefined}
                    argumentType={PLUGIN_ARGUMENT_FIELD_TYPE.SELECT}
                />
            );
        }
    };

    return <div className="fx-plugin-select">{renderContext()}</div>;
};

export default PluginSelect;
